import * as Actions from './actions/actions'
//@ts-ignore
import watch from 'redux-watch';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { AlmeUIMessage, ResponseActionResponse } from '@alme/ui-web/types/response';
import { AlmeResponseV5 } from '@alme/types/response/AlmeResponse';


export default class ProcessedResponseNavigator {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;

        let conversationBaseLocation = this._settings.stateLocations.Conversation.Base;
        let processedResponseLocation =  this._settings.stateLocations.Conversation.processedResponse;

        let watcher = watch(this._store.getState, `${conversationBaseLocation}.${processedResponseLocation}`);
        this._store.subscribe(watcher((newVal: AlmeUIMessage, oldVal: any, objectPath: string) => {
            return this.handleProcessedResponse(newVal, oldVal, objectPath);
        }));
    }

    handleProcessedResponse(newVal: AlmeUIMessage, oldVal: any, objectPath: string) {
        if(!(this.doesHandle(newVal) && this.containsNavLink(newVal))) return;

        let stateLocation = this._settings.stateLocations.AutoNav.stagedNav;

        this._store?.dispatch(Actions.stageAutoNavigation((newVal?.response as AlmeResponseV5)?.navUrl!, stateLocation));
    }

    doesHandle(message: AlmeUIMessage) {
        let handles = false;
        if(message) {
            handles = (message.messageType === this._settings.messageConstants.converseRequest) ||
            (message.messageType === this._settings.messageConstants.requestUnitRequest) ||
            (message.messageType === this._settings.messageConstants.appeventRequest)||
            (message.messageType === this._settings.messageConstants.almeResponseType);
        }
        return handles;
    }

    containsNavLink(message: AlmeUIMessage) {
        let contains = false;
        if(message.response && (message.response as ResponseActionResponse).navUrl) {
            //@ts-ignore
            contains = message.response.navUrl.UrlAddress != undefined
        }
        return contains;
    }
}



// WEBPACK FOOTER //
// ./modules/auto-nav-url-aon/processed-response-watcher.ts